import {t} from "@lingui/core/macro";

import {RequestInfo} from "@repo/shared-core";

/**
 * Returns the block indicating that the external styles are missing.
 */
export const ExternalStylesMissing = () => {
    const infoText = RequestInfo.IS_DEV_SERVER ? (
        `This is usually because the Webpack server is still building or has failed to build. Look in your browser's dev console, or check the Webpack logs with: pnpm tail webpack, to learn more.`
    ) : (
        <>
            {t`If you're behind a web filter, please make sure that the domains *.kastatic.org and *.kasandbox.org are unblocked.`}
            <span id="inaccurate-clock-warning" />
        </>
    );

    return (
        <div
            className="external-styles-missing"
            style={{
                background: "#f2dede",
                font: "14px 'Helvetica Neue', Arial, Helvetica",
                marginBlockEnd: "40px",
                padding: "10px 20px",
            }}
        >
            <p>
                {t`If you're seeing this message, it means we're having trouble loading external resources on our website.`}
            </p>
            <p>{infoText}</p>
        </div>
    );
};
